import { reportPost } from '../../../actions/report-post';

export const reportPostModalResolver = report => reportPost(report);
